import { atom } from "jotai";

import { BookingWizardDataAtom } from "../../stores";

export const courseIdSelectorAtom = atom<string | null>((get) => {
  const bookingWizardData = get(BookingWizardDataAtom);

  return bookingWizardData?.type === "DurationBooking" ||
    bookingWizardData?.type === "LessonBooking"
    ? bookingWizardData.courseId
    : null;
});
